import Header from '../Header/Header';
import { ICONS, Loader } from '@ohif/ui';
import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import { SuccessModal, Select } from '@ohif/ui';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls, _userUrls } from '@custom/Utils/constants/apiUrls';
import { servicesManager } from '../../app/src/App';
import * as Yup from 'yup'
import { customStyle, getCurrencyContact } from '@custom/Utils/utils';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import { useTheme } from "../../ui/src/contextProviders"
import { _roleType } from '@custom/Utils/constants/appConstants';
import { useDispatch, useSelector } from 'react-redux';
import { getValidationSchema } from './schema';
import { AppDispatch, RootState } from '@custom/store/store';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
import hospitalDetailApi from '@custom/rtk-apis/hospital/hospitalDetails';

const AddEditUser = () => {
  const [dateOfBirth, setDateofBirth] = useState<Dayjs | null>(null);
  const { userListResponse } = useSelector((state) => state)
  const fileInputRef = useRef(null);
  const { uiNotificationService } = servicesManager.services

  const [countryCode, setCountryCode] = useState(['+91']); // Default country code
  const [roleList, setRoleList] = useState([])
  const [department, setDepartment] = useState([])
  const [specialitites, setSpecialitities] = useState([]);
  const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
  const hospitalDetailsData = useSelector((state: RootState) => state?.hospitalDetailsResponse);
  const state = useSelector((state: RootState) => state);
  const hospitalId = localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');

  const [edit, setIsEdit] = useState(false)
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState('');
  const [image, setImage] = useState('');
  const [load, setLoad] = useState(false);
  const [gender, setGender] = useState([]);
  const [countryList, setCountryList] = useState([])
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>('+91');

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation()
  const role = sessionStorage.getItem("role") || localStorage.getItem('role');
  const { userData } = location?.state || {}
  const speechToTextAuthorized = state?.hospitalDetailsResponse.result?.addOnsAvailable?.speechToText;
  const aiTrainingAuthorized = state?.hospitalDetailsResponse.result?.addOnsAvailable?.aiServices;
  
  useEffect(() => {
    dispatch(getBillingGeneralSettings());
    dispatch(hospitalDetailApi({ hospitalId: hospitalId }));
  }, [])

  useEffect(() => {
    if (hospitalDetailsData?.status === 'SUCCESS') {
      fetchCommonData();
    }
    if (userData && Object.keys(userData).length > 0) {
      setImage(userData?.profilePic)
      setDateofBirth(dayjs(userData?.dob));
      setIsEdit(true);
    }
  }, [hospitalDetailsData, userData])

  useEffect(() => {
    if (billingGeneralSettingsData?.status === 'success' && billingGeneralSettingsData?.result?.currency) {
      const newCountryCode = getCurrencyContact(billingGeneralSettingsData.result.currency);
      setSelectedCountryCode(newCountryCode);
    }
  }, [billingGeneralSettingsData]);

  const getRoleListAccordingToRole = (list) => {
    const role = sessionStorage.getItem("role") || localStorage.getItem('role');
    const hospitalType = sessionStorage.getItem("hospitalType") || localStorage.getItem('hospitalType');
    if (role === 'ADMIN' || role === 'hospitalsuperadmin') {
      return list
    }
    else if (role === _roleType.superAdmin && hospitalType === 'teraradiology') {
      const userRoles = userListResponse || [];

      const hasRadiologistAdmin = userRoles?.result?.list?.some(user => user.role === "Radiologist Admin");
      const hasPathologistAdmin = userRoles?.result?.list?.some(user => user.role === "Pathologist Admin");

      if (hasRadiologistAdmin && !hasPathologistAdmin) {
        return [...list, "Pathologist Admin"];
      } else if (hasPathologistAdmin && !hasRadiologistAdmin) {
        return [...list, "Radiologist Admin"];
      } else if (!hasRadiologistAdmin && !hasPathologistAdmin) {
        return [...list, "Radiologist Admin", "Pathologist Admin"];
      } else if (hasRadiologistAdmin && hasPathologistAdmin) {
        return list;
      } else {
        return list
      }
    }
    else {
      return list.filter(role => role !== "Admin");
    }

  }
  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        const filteredRoleList = hospitalDetailsData?.result?.government
          ? commonData?.result?.roleList
          : commonData?.result?.roleList.filter((role: string) => role !== 'Government');

        setRoleList(filteredRoleList);
        setCountryList(commonData?.result?.countryList);
        setCountryCode(commonData?.result?.countryCode);
        setDepartment(commonData?.result?.department);
        let allLabels = commonData?.result?.modality
          ?.map(dept => dept.label)
          .join(", ");
        let specialityData = [{ value: "Multi Speciality", label: "Multi Speciality", meta: allLabels }, ...commonData?.result?.modality];
        setSpecialitities(specialityData);
        setGender(commonData?.result?.gender);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchStates = async (country, state, type) => {
    const response: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.statecity, body: { type: type, countryCode: country, stateCode: state }, headerType: 'json' })
    if (response?.status) {
      if (type === 'state') {
        setStates(response.result);
      }
      else {
        setCities(response.result)
      }
      return true
    }
  }

  const handleSaveForm = async (values) => {
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');

    const basePayload = {
      profilePic: image,
      name: values?.name,
      gender: values.gender,
      email: values?.email,
      contactNumberCountryCode: values?.contactNumberCountryCode,
      contactNumber: values?.contactNumber,
      dob: values?.dob?.format('YYYY-MM-DD'),
      whatsappCountryCode: values?.whatsappCountryCode,
      whatsappNumber: values?.whatsappNumber,
      sameAsContact: values?.sameAsContact || false,
      qualification: values?.qualification,
      hospitalId: hospitalId,
    };

    const obj = values?.role === 'Government'
      ?
      {
        ...basePayload,
        role: 'Government',
        country: values?.country,
        state: values?.state,
        city: values.city,
        zipCode: values.zipCode
      } : values?.role === 'hospitalsuperadmin' ? {
        ...basePayload,
        role: values?.role,
        empId: values?.empId,
        hprId: values?.hprId,
        department: values?.department,
        specialization: values?.specialization,
        yearsOfExperience: values?.yearsOfExperience,
        licenseNumber: values?.licenseNumber,
      }
        : {
          ...basePayload,
          role: values?.role,
          empId: values?.empId,
          hprId: values?.hprId,
          department: values?.department,
          specialization: values?.specialization,
          yearsOfExperience: values?.yearsOfExperience,
          licenseNumber: values?.licenseNumber,
        };
    if ((role === _roleType.superAdmin || (role === _roleType.hospitalSuperadmin && values.role !== 'Government'))) {
      obj['speechToText'] = values?.speechToText || false;
    }
    if(role ===_roleType.hospitalSuperadmin || role === _roleType.admin){
      obj['aiTraining'] = values?.aiTraining || false;
    }
    if (values?.role === _roleType.frontDesk) {
      obj['canApproveDiscount'] = values?.aprroveDiscount || false;
    }
    if (values?.role === _roleType.technician) {
      obj['technicianDepartment'] = values?.technicianDepartment || '';
    }
    if (edit) {
      obj['_id'] = userData?._id
    }
    setLoad(true)
    const response = await apiRequest({
      method: 'POST',
      endUrl: _userUrls.add,
      body: obj,
      headerType: 'json',
    });
    setLoad(false);

    if (response?.msg === 'User saved successfully.') {
      setTitle('User saved successfully.');
      setModal(true);
      setTimeout(() => {
        navigate('/users');
      }, 1000);
    } else if (response?.status) {
      setTitle('User saved successfully.');
      setModal(true);
      setTimeout(() => {
        navigate('/users');
      }, 1000);
    } else {
      uiNotificationService.show({
        title: 'Error',
        type: 'error',
        message: response.msg,
        position: 'topRight',
      })
    }
  }
  const cancel = () => {
    navigate("/users");
  }

  const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency ? getCurrencyContact(billingGeneralSettingsData.result.currency) : '+91';

  let initialValues = {
    name: userData?.name || '',
    contactNumberCountryCode: edit ? userData?.contactNumberCountryCode || userData?.countryCode : defaultCountryCode,
    whatsappCountryCode: edit ? userData?.whatsappCountryCode : defaultCountryCode,
    empId: userData?.empId || '',
    role: userData?.role === 'Technician Radiology' ? 'Technician' : userData?.role === 'Hospital Superadmin' ? 'hospitalsuperadmin' : (userData?.role || ''),
    hprId: userData?.hprId || '',
    gender: userData?.gender || '',
    email: userData?.email || '',
    contactNumber: userData?.contactNumber || '',
    dob: userData?.dob ? dayjs(userData?.dob) : null,
    department: userData?.department || '',
    specialization: userData?.specialization || '',
    yearsOfExperience: userData?.yearsOfExperience || '',
    whatsappNumber: userData?.whatsappNumber || '',
    qualification: userData?.qualification || '',
    licenseNumber: userData?.licenseNumber || '',
    sameAsContact: (userData?.contactNumber && userData?.whatsappNumber && userData?.contactNumber === userData?.whatsappNumber && userData?.contactNumberCountryCode === userData?.whatsappCountryCode) || false,
    speechToText: userData ? (userData?.speechToText || false) : '',
    aiTraining: userData ? (userData?.aiTraining || false) : '',
    aprroveDiscount: userData?.canApproveDiscount || false,
       technicianDepartment: userData ? (userData?.technicianDepartment || 'Pathology') : '',
  }

  const isDarkMode = useTheme();

  const checkSpeechToTextPermission = (values) => {
    if (
      speechToTextAuthorized &&
      (role === _roleType.hospitalSuperadmin || role === _roleType.admin) &&
      (
        values?.role === _roleType.radiologist ||
        values?.role === _roleType.pathologist ||
        values?.role === _roleType.admin ||
        values?.role === _roleType.hospitalSuperadmin
      )
    ) {
      return true;
    }
    return false;
  }
  const checkAITrainingPermission = (values) => {
    if (
      aiTrainingAuthorized &&
      (role === _roleType.hospitalSuperadmin || role === _roleType.admin) &&
      (
        values?.role === _roleType.radiologist ||
        values?.role === _roleType.pathologist ||
        values?.role === _roleType.admin ||
        values?.role === _roleType.hospitalSuperadmin
      )
    ) {
      return true;
    }
    return false;
  }


  return (
    <div className='page page__full' style={isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground}>
      <Header isBack={true} title={"Users"}></Header>
      <div className='page__body'>
        <div className='details'>
          <div className='form form--innersec'>
            <section className='form__section'>
              <h1 className='form__section__title'>{edit ? "Edit" : "Add"} User</h1>
              <div className="formRow">
                <div className="formCol">
                  <div className="form__Field">
                    <label className="form__uploadProfile" htmlFor="uploadProfile">
                      {image && <img className="form__uploadProfile__picture" src={image} alt="" />}
                      <img className="form__uploadProfile__picture" src={ICONS.defaultUserIcon} alt="" />
                      <span className="form__uploadProfile__overlay">
                        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.4782 12.1589C15.4782 12.5125 15.3377 12.8516 15.0877 13.1017C14.8376 13.3517 14.4985 13.4922 14.1449 13.4922H2.14486C1.79124 13.4922 1.4521 13.3517 1.20205 13.1017C0.951999 12.8516 0.811523 12.5125 0.811523 12.1589V4.82552C0.811523 4.4719 0.951999 4.13276 1.20205 3.88271C1.4521 3.63266 1.79124 3.49219 2.14486 3.49219H4.81152L6.14486 1.49219H10.1449L11.4782 3.49219H14.1449C14.4985 3.49219 14.8376 3.63266 15.0877 3.88271C15.3377 4.13276 15.4782 4.4719 15.4782 4.82552V12.1589Z" stroke="white" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M8.14486 10.8255C9.61762 10.8255 10.8115 9.63161 10.8115 8.15885C10.8115 6.68609 9.61762 5.49219 8.14486 5.49219C6.6721 5.49219 5.47819 6.68609 5.47819 8.15885C5.47819 9.63161 6.6721 10.8255 8.14486 10.8255Z" stroke="white" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </span>
                    </label>
                    <input type="file" id="uploadProfile" className="form__uploadfiled" ref={fileInputRef}
                      onChange={handleImageChange} />
                  </div>
                </div>
              </div>
              <Formik
                initialValues={initialValues}
                validationSchema={Yup.lazy((values) => getValidationSchema(values.role))}
                onSubmit={handleSaveForm}
              >
                {({
                  errors,
                  values,
                  handleChange,
                  handleBlur,
                  touched,
                  setFieldValue,
                  setFieldTouched,
                  setFieldError,
                }) => {
                  useEffect(() => {
                    if (edit && userData) {
                      setFieldValue('contactNumberCountryCode', userData?.contactNumberCountryCode || userData?.countryCode);
                      setFieldValue('whatsappCountryCode', userData?.whatsappCountryCode);
                    } else {
                      setFieldValue('contactNumberCountryCode', selectedCountryCode);
                      setFieldValue('whatsappCountryCode', selectedCountryCode);
                    }
                    if (values.role === 'Government' && !roleList.includes('Government')) {
                      setRoleList(prev => [...prev, 'Government']);
                    }
                    if (values.role === 'hospitalsuperadmin' && !roleList.includes('hospitalsuperadmin')) {
                      setRoleList(prev => [...prev, 'hospitalsuperadmin']);
                    }
                  }, [selectedCountryCode, roleList, userData, edit]);
                  return(
                    <Form >
                      {values.role === 'Government' ? (
                        <>
                          <div className='formRow formRow__4'>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='name'>
                                  Name
                                  <span className="required-asterisk">*</span>
                                </label>
                                <input className="form__input form__input--sm"
                                  type="text"
                                  id="name"
                                  name="name"
                                  placeholder="Name"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.name}
                                  autoComplete='off'
                                />
                                <ErrorMessage name="name" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label">
                                  User Role<span className="required-asterisk">*</span>
                                </label>
                                <select
                                  className="form__select form__select--sm"
                                  id="role"
                                  name="role"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.role}
                                  autoComplete='off'
                                  disabled={edit ? true : false}
                                  style={customStyle.select}
                                >
                                  <option value="">Select</option>
                                  {getRoleListAccordingToRole(roleList).map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <ErrorMessage name="role" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label">
                                  Email ID<span className="required-asterisk">*</span>
                                </label>
                                <input
                                  className="form__input form__input--sm"
                                  type="text"
                                  id="email"
                                  name="email"
                                  placeholder="Email ID"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.email}
                                  disabled={edit ? true : false}
                                  autoComplete='off'
                                />
                                <ErrorMessage name="email" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='gender'>Gender</label>
                                <div className="form__radio mt-4">
                                  {gender.map((option) => (
                                    <div className="form__radio__option mb_0">
                                      <input type="radio" name="gender"
                                        value={option.value}
                                        checked={option.value === values?.gender}
                                        onChange={handleChange}
                                        className="form__radio__input" />
                                      <label className="form__radio__label" htmlFor="addAgentWeightZone">{option.label}</label>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='formRow formRow__4'>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='country' >Country</label>
                                <select
                                  id="country"
                                  name="country"
                                  className="form__select form__select--sm"
                                  onChange={(e) => {
                                    handleChange(e);
                                    fetchStates(e.target.value, '', 'state')
                                  }}
                                  onBlur={handleBlur}
                                  value={values.country}
                                  style={customStyle.select}
                                >
                                  <option value="">-Select-</option>
                                  {countryList.map((option) => (
                                    <option key={option.value} value={option.value}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='state'>State</label>
                                <select
                                  id="state"
                                  name="state"
                                  className="form__select form__select--sm"
                                  onChange={(e) => {
                                    handleChange(e);
                                    fetchStates(values.country, e.target.value, 'city')
                                  }}
                                  onBlur={handleBlur}
                                  value={values.state}
                                  style={customStyle.select}
                                >
                                  <option value="">-Select-</option>
                                  {states.map((option) => (
                                    <option key={option.isoCode} value={option.isoCode}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='city'>City</label>
                                <select
                                  id="city"
                                  name="city"
                                  className="form__select form__select--sm"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.city}
                                  style={customStyle.select}
                                >
                                  <option value="">-Select-</option>
                                  {cities.map((option) => (
                                    <option key={option.name} value={option.name}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='zipCode'>Zip Code</label>
                                <input
                                  type="text"
                                  id="zipCode"
                                  name="zipCode"
                                  placeholder="ZipCode"
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                    e.target.value = value;
                                    handleChange(e);
                                  }}
                                  onBlur={handleBlur}
                                  maxLength={6}
                                  value={values.zipCode}
                                  className="form__input form__input--sm"
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                />
                              </div>
                              <ErrorMessage name="zipCode" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formRow formRow__4'>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label">
                                  Date of Birth{values?.role !== _roleType.hospitalSuperadmin && <span className="required-asterisk">*</span>}
                                </label>
                                <div className="form__date-container">
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Field name="dob" style={{ width: '100%' }}>
                                      {({ field }) => (
                                        <DatePicker
                                          sx={{
                                            width: '100%',
                                            '& .MuiInputBase-root': {
                                              backgroundColor: '#F6FFFF',
                                              borderRadius: '2rem'
                                            },
                                            '& .MuiInputBase-input': {
                                              padding: '10px',
                                            },
                                          }}
                                          {...field}
                                          value={field.value || null}
                                          format="DD/MM/YYYY"
                                          maxDate={dayjs()}
                                          onChange={(newValue) => {
                                            setFieldValue(field.name, newValue);
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              error={touched.date && Boolean(errors.date)}
                                              helperText={touched.date && errors.date}
                                            />
                                          )}
                                        />
                                      )}
                                    </Field>
                                  </LocalizationProvider>
                                </div>
                                <ErrorMessage name="dob" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='name'>
                                  Contact Number<span className="required-asterisk">*</span>
                                </label>
                                <div className='form__groupField form__groupField--phonenumber'>
                                  <select className="form__select form__select--sm" id="contactNumberCountryCode"
                                    name="contactNumberCountryCode"
                                    value={values.contactNumberCountryCode}
                                    style={customStyle.select}
                                    onChange={(e) => {
                                      handleChange(e);
                                      if (values.sameAsContact) {
                                        setFieldValue('whatsappCountryCode', e.target.value);
                                        setFieldValue('whatsappNumber', values?.contactNumber);
                                      }
                                      setFieldValue('sameAsContact', values.contactNumber && values.whatsappNumber && values.contactNumber === values.whatsappNumber && e.target.value === values.whatsappCountryCode);
                                    }}>
                                    {countryCode.map((option) => (
                                      <option
                                        key={option}
                                        value={option}
                                      >
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                  <input
                                    type="text"
                                    className="form__input form__input--sm"
                                    id="contactNumber"
                                    name="contactNumber"
                                    placeholder="Contact Number"
                                    maxLength={10}
                                    pattern="[0-9]*"
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    }}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue('sameAsContact', e.target.value && values.whatsappNumber && e.target.value === values.whatsappNumber && values.contactNumberCountryCode === values.whatsappCountryCode);
                                    }}
                                    value={values.contactNumber}
                                    autoComplete="off"
                                  />
                                </div>
                                <ErrorMessage name="contactNumber" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='whatsappNumber'>Whatsapp Number</label>
                                <div className="form__groupField form__groupField--phonenumber">
                                  <select
                                    id="whatsappCountryCode"
                                    className="form__select form__select--sm"
                                    name="whatsappCountryCode"
                                    value={values.whatsappCountryCode}
                                    style={customStyle.select}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue('sameAsContact', values.contactNumber && values.whatsappNumber && values.contactNumber === values.whatsappNumber && e.target.value === values.contactNumberCountryCode);
                                    }}
                                  >
                                    {countryCode.map((option) => (
                                      <option
                                        key={option}
                                        value={option}
                                      >
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                  <input
                                    type="text"
                                    className="form__input form__input--sm"
                                    id="whatsappNumber"
                                    name="whatsappNumber"
                                    placeholder="Whatsapp Number"
                                    maxLength={10}
                                    onChange={(e) => {
                                      const newWhatsappNumber = e.target.value.replace(/[^0-9]/g, '');
                                      e.target.value = newWhatsappNumber;
                                      handleChange(e);
                                      setFieldValue('sameAsContact', values.contactNumber && newWhatsappNumber && values.contactNumber === newWhatsappNumber && values.contactNumberCountryCode === values.whatsappCountryCode);
                                    }}
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    }}
                                    pattern="[0-9]*"
                                    onBlur={handleBlur}
                                    value={values.whatsappNumber}
                                    autoComplete='off'
                                  />
                                </div>
                                <div className="form__checkboxSubField">
                                  <div className="form__checkbox">
                                    <div className="form__checkbox__option m_0">
                                      <input className="form__checkbox__input" id='sameAsContact' checked={values.sameAsContact} type="checkbox" name="sameAsContact" value="sameAsContact" style={customStyle.checkbox} onChange={(e) => {
                                        setFieldValue('sameAsContact', e.target.checked);
                                        if (e.target.checked) {
                                          setFieldValue('whatsappNumber', values.contactNumber);
                                          setFieldValue('whatsappCountryCode', values?.contactNumberCountryCode);
                                        } else {
                                          setFieldValue('whatsappNumber', '');
                                          setFieldValue('whatsappCountryCode', defaultCountryCode);
                                        }
                                      }} />
                                      <label htmlFor="sameAsContact" className="form__checkbox__label"> Same as Contact Number</label>
                                    </div>
                                  </div>
                                </div>
                                <ErrorMessage name="whatsappNumber" component="div" className="error text-error" />
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className='formRow formRow__4'>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='name'>
                                  Name
                                  <span className="required-asterisk">*</span>
                                </label>
                                <input className="form__input form__input--sm"
                                  type="text"
                                  id="name"
                                  name="name"
                                  placeholder="Name"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.name}
                                  autoComplete='off'
                                  disabled={values?.role === 'hospitalsuperadmin'}
                                />
                              </div>
                              <ErrorMessage name="name" component="div" className="error text-error" />
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label">
                                  User Role<span className="required-asterisk">*</span>
                                </label>
                                <select
                                  className="form__select form__select--sm"
                                  id="role"
                                  name="role"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.role}
                                  autoComplete='off'
                                  disabled={edit ? true : false}
                                  style={customStyle.select}
                                >
                                  <option value="">Select</option>
                                  {getRoleListAccordingToRole(roleList).map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <ErrorMessage name="role" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='employeeId' >
                                  Employee ID
                                </label>
                                <input
                                  className="form__input form__input--sm"
                                  type="text"
                                  id="empId"
                                  name="empId"
                                  placeholder="Employee ID"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    const paste = (e.clipboardData || window.clipboardData).getData('text');
                                    const numericPaste = paste.replace(/[^0-9]/g, '');
                                    e.target.value = numericPaste;
                                    handleChange(e);
                                  }}
                                  value={values.empId}
                                  autoComplete='off'
                                  disabled={values?.role === 'hospitalsuperadmin'}
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='hprId'>
                                  HPR ID
                                </label>
                                <input
                                  className="form__input form__input--sm"
                                  type="text"
                                  id="hprId"
                                  name="hprId"
                                  placeholder="HPR ID"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    const paste = (e.clipboardData || window.clipboardData).getData('text');
                                    const numericPaste = paste.replace(/[^0-9]/g, '');
                                    e.target.value = numericPaste;
                                    handleChange(e);
                                  }}
                                  value={values.hprId}
                                  autoComplete='off'
                                  disabled={values?.role === 'hospitalsuperadmin'}
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                />
                              </div>
                            </div>
                          </div>
                          <div className='formRow formRow__4'>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label">
                                  Email ID<span className="required-asterisk">*</span>
                                </label>
                                <input
                                  className="form__input form__input--sm"
                                  type="text"
                                  id="email"
                                  name="email"
                                  placeholder="Email ID"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.email}
                                  disabled={edit ? true : false}
                                  autoComplete='off'
                                  disabled={values?.role === 'hospitalsuperadmin'}
                                />
                                <ErrorMessage name="email" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='gender'>Gender</label>
                                <div className="form__radio mt-4">
                                  {gender.map((option) => (
                                    <div className="form__radio__option mb_0">
                                      <input type="radio" name="gender"
                                        value={option.value}
                                        checked={option.value === values?.gender}
                                        onChange={handleChange}
                                        disabled={values?.role === 'hospitalsuperadmin'}
                                        className="form__radio__input" />
                                      <label className="form__radio__label" htmlFor="addAgentWeightZone">{option.label}</label>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label">
                                  Date of Birth{values?.role !== _roleType.hospitalSuperadmin && <span className="required-asterisk">*</span>}
                                </label>
                                <div className="form__date-container">
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Field name="dob" style={{ width: '100%' }}>
                                      {({ field }) => (
                                        <DatePicker
                                          sx={{
                                            width: '100%',
                                            '& .MuiInputBase-root': {
                                              backgroundColor: '#F6FFFF',
                                              borderRadius: '2rem'
                                            },
                                            '& .MuiInputBase-input': {
                                              padding: '10px',
                                            },
                                          }}
                                          {...field}
                                          value={field.value || null}
                                          format="DD/MM/YYYY"
                                          maxDate={dayjs()}
                                          onChange={(newValue) => {
                                            setFieldValue(field.name, newValue);
                                          }}
                                          disabled={values?.role === 'hospitalsuperadmin'}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              error={touched.date && Boolean(errors.date)}
                                              helperText={touched.date && errors.date}
                                            />
                                          )}
                                        />
                                      )}
                                    </Field>
                                  </LocalizationProvider>
                                </div>
                                <ErrorMessage name="dob" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='numberOfHealthcareProfessionals'>Years of Experience</label>
                                <input
                                  className="form__input form__input--sm"
                                  type="number"
                                  id="yearsOfExperience"
                                  name="yearsOfExperience"
                                  placeholder="--"
                                  min='0'
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.yearsOfExperience}
                                  autoComplete='off'
                                  disabled={values?.role === 'hospitalsuperadmin'}
                                />
                              </div>
                            </div>
                          </div>
                          <div className='formRow formRow__4'>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label">
                                  Department
                                </label>
                                <select
                                  id="department"
                                  name="department"
                                  className="form__select form__select--sm"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.department}
                                  style={customStyle.select}
                                  autoComplete='off'
                                  disabled={values?.role === 'hospitalsuperadmin'}
                                >
                                  <option value="">Select</option>
                                  {department.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='numberOfHealthcareProfessionals'>Specialization</label>
                                <Select id='specialization'
                                  placeholder='Select'
                                  isMulti={true}
                                  isClearable={false}
                                  isSearchable={false}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  options={specialitites}
                                  value={values.specialization}
                                  onChange={(selectedOptions) => {
                                    const newSpecialties = selectedOptions ? selectedOptions.map(option => option) : [];
                                    setFieldValue('specialization', newSpecialties);
                                  }
                                  }
                                  isDisabled={values?.role === 'hospitalsuperadmin'}
                                ></Select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='name'>
                                  Contact Number<span className="required-asterisk">*</span>
                                </label>
                                <div className='form__groupField form__groupField--phonenumber'>
                                  <select className="form__select form__select--sm" id="contactNumberCountryCode"
                                    name="contactNumberCountryCode"
                                    value={values.contactNumberCountryCode}
                                    style={customStyle.select}
                                    disabled={values?.role === 'hospitalsuperadmin'}
                                    onChange={(e) => {
                                      handleChange(e);
                                      if (values.sameAsContact) {
                                        setFieldValue('whatsappCountryCode', e.target.value);
                                        setFieldValue('whatsappNumber', values?.contactNumber);
                                      }
                                      setFieldValue('sameAsContact', values.contactNumber && values.whatsappNumber && values.contactNumber === values.whatsappNumber && e.target.value === values.whatsappCountryCode);
                                    }}>
                                    {countryCode.map((option) => (
                                      <option
                                        key={option}
                                        value={option}
                                      >
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                  <input
                                    type="text"
                                    className="form__input form__input--sm"
                                    id="contactNumber"
                                    name="contactNumber"
                                    placeholder="Contact Number"
                                    maxLength={10}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue('sameAsContact', e.target.value && values.whatsappNumber && e.target.value === values.whatsappNumber && values.contactNumberCountryCode === values.whatsappCountryCode);
                                    }}
                                    disabled={values?.role === 'hospitalsuperadmin'}
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    }}
                                    pattern="[0-9]*"
                                    value={values.contactNumber}
                                    autoComplete="off"
                                  />
                                </div>
                                <ErrorMessage name="contactNumber" component="div" className="error text-error" />
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='whatsappNumber'>Whatsapp Number</label>
                                <div className="form__groupField form__groupField--phonenumber">
                                  <select
                                    id="whatsappCountryCode"
                                    className="form__select form__select--sm"
                                    name="whatsappCountryCode"
                                    value={values.whatsappCountryCode}
                                    style={customStyle.select}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue('sameAsContact', values.contactNumber && values.whatsappNumber && values.contactNumber === values.whatsappNumber && e.target.value === values.contactNumberCountryCode);
                                    }}
                                    disabled={values?.role === 'hospitalsuperadmin'}
                                  >
                                    {countryCode.map((option) => (
                                      <option
                                        key={option}
                                        value={option}
                                      >
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                  <input
                                    type="text"
                                    className="form__input form__input--sm"
                                    id="whatsappNumber"
                                    name="whatsappNumber"
                                    placeholder="Whatsapp Number"
                                    maxLength={10}
                                    onChange={(e) => {
                                      const newWhatsappNumber = e.target.value.replace(/[^0-9]/g, '');
                                      e.target.value = newWhatsappNumber;
                                      handleChange(e);
                                      setFieldValue('sameAsContact', values.contactNumber && newWhatsappNumber && values.contactNumber === newWhatsappNumber && values.contactNumberCountryCode === values.whatsappCountryCode);
                                    }}
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    }}
                                    pattern="[0-9]*"
                                    onBlur={handleBlur}
                                    value={values.whatsappNumber}
                                    disabled={values?.role === 'hospitalsuperadmin'}
                                    autoComplete='off'>
                                  </input>
                                </div>
                                <div className="form__checkboxSubField">
                                  <div className="form__checkbox">
                                    <div className="form__checkbox__option m_0">
                                      <input className="form__checkbox__input" id='sameAsContact' checked={values.sameAsContact} disabled={values?.role === 'hospitalsuperadmin'} type="checkbox" name="sameAsContact" value="sameAsContact" style={customStyle.checkbox} onChange={(e) => {
                                        setFieldValue('sameAsContact', e.target.checked);
                                        if (e.target.checked) {
                                          setFieldValue('whatsappNumber', values.contactNumber);
                                          setFieldValue('whatsappCountryCode', values?.contactNumberCountryCode)
                                        } else {
                                          setFieldValue('whatsappNumber', '');
                                          setFieldValue('whatsappCountryCode', defaultCountryCode);
                                        }
                                      }} />
                                      <label htmlFor="sameAsContact" className="form__checkbox__label"> Same as Contact Number</label>
                                    </div>
                                  </div>
                                </div>
                                <ErrorMessage name="whatsappNumber" component="div" className="error text-error" />
                              </div>
                            </div>
                          </div>
                          <div className='formRow formRow__4'>
                            <div className='formCol'>
                              <div className="form__Field">
                                <label className="form__label" htmlFor='numberOfHealthcareProfessionals'>
                                  State Medical Council Registration License Number
                                  {values?.role !== _roleType.admin && values?.role !== _roleType.frontDesk && values?.role !== _roleType.technician && values?.role !== _roleType.hospitalSuperadmin && <span className="required-asterisk">*</span>}
                                </label>
                                <input
                                  type="text"
                                  className="form__input form__input--sm"
                                  id="licenseNumber"
                                  name="licenseNumber"
                                  placeholder="License Number"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.licenseNumber}
                                  autoComplete='off'
                                  disabled={values?.role === 'hospitalsuperadmin'}
                                />
                                <ErrorMessage name="licenseNumber" component="div" className="error text-error" />
                              </div>
                            </div>
                            {(values?.role === _roleType.pathologist || values?.role === _roleType.radiologist) && (
                              <div className='formCol'>
                                <div className="form__Field">
                                  <label className="form__label" htmlFor='numberOfHealthcareProfessionals'>
                                    Qualification
                                  </label>
                                  <input
                                    type="text"
                                    className="form__input form__input--sm"
                                    id="qualification"
                                    name="qualification"
                                    placeholder="Qualification"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.qualification}
                                    autoComplete='off'
                                    disabled={values?.role === 'hospitalsuperadmin'}
                                  />
                                  <ErrorMessage name="qualification" component="div" className="error text-error" />
                                </div>
                              </div>
                            )}
                            {
                              values?.role === _roleType.frontDesk &&
                              <>
                                {/* <div className="form__checkboxSubField">
                          <div className="form__checkbox">
                            <div className="form__checkbox__option m_0">
                              <input className="form__checkbox__input" id='aprroveDiscount' checked={values.aprroveDiscount} type="checkbox" name="aprroveDiscount" value="aprroveDiscount" style={customStyle.checkbox}
                              onChange={(e)=>{
                                setFieldValue('aprroveDiscount', e.target.checked);
                              }}
                              />
                              <label htmlFor="aprroveDiscount" className="form__checkbox__label">Authorized to approve discount</label>
                            </div>
                          </div>
                        </div> */}
                                <div className='formCol flex items-end'>
                                  <div className="form__Field mb-[12px]">
                                    <label className="form__label">Authorized to approve discount</label>
                                    <div className="form__radio mt-4">
                                      <div className="form__radio__option mb_0 mr-4">
                                        <input
                                          type="radio"
                                          className="form__radio__input"
                                          id='aprroveDiscountEnable'
                                          checked={values.aprroveDiscount === true}
                                          name="aprroveDiscount"
                                          value="enable"
                                          onChange={(e) => {
                                            setFieldValue('aprroveDiscount', true);
                                          }}
                                        />
                                        <label htmlFor="aprroveDiscount" className="form__radio__label">Enable</label>
                                      </div>
                                      <div className="form__radio__option mb_0">
                                        <input
                                          type="radio"
                                          className="form__radio__input"
                                          id='aprroveDiscountDisable'
                                          checked={values.aprroveDiscount === false}
                                          name="aprroveDiscount"
                                          value="disable"
                                          onChange={(e) => {
                                            setFieldValue('aprroveDiscount', false);
                                          }}
                                        />
                                        <label htmlFor="speechToTextDisable" className="form__radio__label">Disable</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            }
                            {checkSpeechToTextPermission(values) && (
                              <div className='formCol flex items-end'>
                                <div className="form__Field mb-[12px]">
                                  <label className="form__label">Speech To Text</label>
                                  <div className="form__radio mt-4">
                                    <div className="form__radio__option mb_0 mr-4">
                                      <input
                                        type="radio"
                                        className="form__radio__input"
                                        id='speechToTextEnable'
                                        checked={values.speechToText === true}
                                        name="speechToText"
                                        value="enable"
                                        onChange={(e) => {
                                          setFieldValue('speechToText', true);
                                        }}
                                      />
                                      <label htmlFor="speechToTextEnable" className="form__radio__label">Enable</label>
                                    </div>
                                    <div className="form__radio__option mb_0">
                                      <input
                                        type="radio"
                                        className="form__radio__input"
                                        id='speechToTextDisable'
                                        checked={values.speechToText === false}
                                        name="speechToText"
                                        value="disable"
                                        onChange={(e) => {
                                          setFieldValue('speechToText', false);
                                        }}
                                      />
                                      <label htmlFor="speechToTextDisable" className="form__radio__label">Disable</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                             {checkAITrainingPermission(values) && (
                              <div className='formCol flex items-end'>
                                <div className="form__Field mb-[12px]">
                                  <label className="form__label">AI Training</label>
                                  <div className="form__radio mt-4">
                                    <div className="form__radio__option mb_0 mr-4">
                                      <input
                                        type="radio"
                                        className="form__radio__input"
                                        id='aiTrainingEnable'
                                        checked={values.aiTraining === true}
                                        name="aiTraining"
                                        value="enable"
                                        onChange={(e) => {
                                          setFieldValue('aiTraining', true);
                                        }}
                                      />
                                      <label htmlFor="aiTrainingEnable" className="form__radio__label">Enable</label>
                                    </div>
                                    <div className="form__radio__option mb_0">
                                      <input
                                        type="radio"
                                        className="form__radio__input"
                                        id='aiTrainingDisable'
                                        checked={values.aiTraining === false}
                                        name="aiTraining"
                                        value="disable"
                                        onChange={(e) => {
                                          setFieldValue('aiTraining', false);
                                        }}
                                      />
                                      <label htmlFor="aiTrainingDisable" className="form__radio__label">Disable</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                             {values.role === _roleType.technician && (
                              <div className='formCol'>
                                <div className="form__Field">
                                  <label className="form__label">
                                   Technician Department
                                    <span className="required-asterisk">*</span>
                                  </label>
                                  <div className="form__radio mt-4">
                                    <div className="form__radio__option mb_0">
                                      <input
                                        type="radio"
                                        name="technicianDepartment"
                                        value="Radiology"
                                        checked={values.technicianDepartment === 'Radiology'}
                                        onChange={handleChange}
                                        disabled={edit} 
                                        className="form__radio__input"
                                      />
                                      <label className="form__radio__label">Radiology</label>
                                    </div>
                                    <div className="form__radio__option mb_0">
                                      <input
                                        type="radio"
                                        name="technicianDepartment"
                                        value="Pathology"
                                        checked={values.technicianDepartment === 'Pathology'}
                                        onChange={handleChange}
                                        disabled={edit} 
                                        className="form__radio__input"
                                      />
                                      <label className="form__radio__label">Pathology</label>
                                    </div>
                                  </div>
                                  <ErrorMessage name="technicianDepartment" component="div" className="error text-error" />
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                      <div className='btn__group'>
                        <button
                          className='btn btn__white'
                          onClick={cancel}
                        >
                          Cancel
                        </button>
                        <button
                          className='btn btn__primary'
                          type="submit"
                        >
                          {edit ? "Update" : "Save"}
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </section>
          </div>
        </div>
      </div>
      <Loader isLoaderOpen={load} />
      <SuccessModal
        isSuccessModalOpen={modal}
        title={title}
        handleCloseModal={() => setModal(false)}
      />
    </div>
  )
}

export default AddEditUser
